"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSliderModalContext = exports.SliderModalContext = void 0;
var _reactUtils = require("@cian/react-utils");
const {
  Context: SliderModalContext,
  useContext: useSliderModalContext
} = (0, _reactUtils.makeContextModule)({
  contextName: 'SliderModalContext'
});
exports.useSliderModalContext = useSliderModalContext;
exports.SliderModalContext = SliderModalContext;